import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import useTrackingStorage, { TRACKING_PARAMS, type TrackingProps } from '@/hooks/use-tracking-storage';

// The website's links land on sign-in, and the query string is gone by the time the demo form opens.
const useCaptureTrackingParams = () => {
  const $ = _c(5);
  const {
    query,
    isReady
  } = useRouter();
  const {
    update
  } = useTrackingStorage();
  let t0;
  let t1;
  if ($[0] !== isReady || $[1] !== query || $[2] !== update) {
    t0 = () => {
      if (!isReady) {
        return;
      }
      const captured = {};
      for (const [param, field] of Object.entries(TRACKING_PARAMS)) {
        const value = query[param];
        if (typeof value === "string") {
          captured[field] = value;
        }
      }
      if (Object.keys(captured).length > 0) {
        update(captured);
      }
    };
    t1 = [isReady, query, update];
    $[0] = isReady;
    $[1] = query;
    $[2] = update;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
};
export default useCaptureTrackingParams;